'use strict';

const setCookie = (name, value, exdays) => {
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${expirationDate.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};

const readCookie = (name) => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';').map(cookie => cookie.trim());

  for (const cookie of ca) {
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
};

export { setCookie, readCookie }
